import styled, { css } from 'styled-components';
import AvailabilityIcon from '../AvailabilityIcon/AvailabilityIcon';
var StyledAvailabilityIcon = styled(AvailabilityIcon).withConfig({
  displayName: "AvailabilityResultstyles__StyledAvailabilityIcon",
  componentId: "sc-13xpu43-0"
})(["margin-right:10px;"]);
var AvailabilityResultList = styled.li.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultList",
  componentId: "sc-13xpu43-1"
})(["background:", ";border:1px solid ", ";border-radius:3px;display:block;overflow:visible;margin-bottom:", ";position:relative;padding:0;", ""], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.isMoreAvailabilityResult ? '0px' : '10px';
}, function (props) {
  return props.active && css([""]);
});
var AvailabilityResultHeadingButton = styled.button.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeadingButton",
  componentId: "sc-13xpu43-2"
})(["background:none;border:0;font-size:1em;padding:0;text-align:left;width:100%;"]);
var AvailabilityResultHeading = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeading",
  componentId: "sc-13xpu43-3"
})(["padding:0;margin:15px;cursor:pointer;"]);
var AvailabilityResultHeadingMessage = styled.span.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeadingMessage",
  componentId: "sc-13xpu43-4"
})(["color:", ";"], function (props) {
  return props.theme.color.palette['brand-1-dark'];
});
var AvailabilityResultHeadingChevron = styled.span.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeadingChevron",
  componentId: "sc-13xpu43-5"
})(["fill:", ";margin-left:3px;"], function (props) {
  return props.theme.color.palette['brand-1-dark'];
});
var AvailabilityResultHeadingCollect = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeadingCollect",
  componentId: "sc-13xpu43-6"
})(["display:flex;position:relative;align-items:center;"]);
var AvailabilityResultHeadingCollectTitle = styled.p.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeadingCollectTitle",
  componentId: "sc-13xpu43-7"
})(["&&&{margin:0;line-height:1;flex-grow:1;padding-right:5px;font-weight:", ";}"], function (props) {
  return props.theme.font.weight.bold;
});
var AvailabilityResultStoreDetails = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultStoreDetails",
  componentId: "sc-13xpu43-8"
})(["flex-grow:1;padding:0 15px;"]);
var AvailabilityResultHeadingDivider = styled.span.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeadingDivider",
  componentId: "sc-13xpu43-9"
})(["width:100%;height:1px;display:block;background-color:", ";"], function (props) {
  return props.theme.color.monochrome.light;
});
var AvailabilityResultHeadingBottomHalf = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultHeadingBottomHalf",
  componentId: "sc-13xpu43-10"
})(["position:relative;padding:20px 0;"]);
var StoreDetailsParagraph = styled.p.withConfig({
  displayName: "AvailabilityResultstyles__StoreDetailsParagraph",
  componentId: "sc-13xpu43-11"
})(["font-size:22px;display:inline-block;margin-right:10px;margin-bottom:5px;word-wrap:break-word;color:", ";"], function (props) {
  return props.theme.color.monochrome.darker;
});
var StoreAddressParagraph = styled.p.withConfig({
  displayName: "AvailabilityResultstyles__StoreAddressParagraph",
  componentId: "sc-13xpu43-12"
})(["color:", ";"], function (props) {
  return props.theme.color.monochrome.dark;
});
var StoreDetailsSpaceBetween = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__StoreDetailsSpaceBetween",
  componentId: "sc-13xpu43-13"
})(["display:flex;align-items:center;justify-content:space-between;"]);
var StoreDetailsDistance = styled.p.withConfig({
  displayName: "AvailabilityResultstyles__StoreDetailsDistance",
  componentId: "sc-13xpu43-14"
})(["&&&{display:inline-block;margin-top:10px;color:", ";}"], function (props) {
  return props.theme.color.monochrome.dark;
});
var AccordionResultCTA = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AccordionResultCTA",
  componentId: "sc-13xpu43-15"
})(["display:flex;justify-content:flex-end;align-items:center;padding:15px 15px 0;margin-top:0;width:100%;a{flex-grow:1;}"]);
var ColumnResultCTA = styled(AccordionResultCTA).withConfig({
  displayName: "AvailabilityResultstyles__ColumnResultCTA",
  componentId: "sc-13xpu43-16"
})(["justify-content:space-between;width:100%;"]);
var AvailabilityResultDrawerContent = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultDrawerContent",
  componentId: "sc-13xpu43-17"
})(["transition:0.7s ease-out;max-height:0;overflow:hidden;transform-style:preserve-3d;backface-visibility:hidden;width:100%;", ""], function (props) {
  return props.active && css(["&&&{transition:1s ease-in;max-height:1000px;}"]);
});
var AvailabilityResultDrawerContentMargin = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultDrawerContentMargin",
  componentId: "sc-13xpu43-18"
})(["margin:0 15px;"]);
var AvailabilityResultDrawerButtonWrapper = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultDrawerButtonWrapper",
  componentId: "sc-13xpu43-19"
})(["display:flex;justify-content:flex-end;"]);
var AvailabilityResultMessageContainer = styled.div.withConfig({
  displayName: "AvailabilityResultstyles__AvailabilityResultMessageContainer",
  componentId: "sc-13xpu43-20"
})(["display:flex;flex-wrap:nowrap;"]);
export { AvailabilityResultList, AvailabilityResultHeadingButton, AvailabilityResultHeading, AvailabilityResultHeadingMessage, AvailabilityResultHeadingChevron, AvailabilityResultHeadingCollect, AvailabilityResultHeadingCollectTitle, StyledAvailabilityIcon, AvailabilityResultHeadingDivider, AvailabilityResultHeadingBottomHalf, StoreDetailsParagraph, StoreAddressParagraph, StoreDetailsSpaceBetween, StoreDetailsDistance, AccordionResultCTA, ColumnResultCTA, AvailabilityResultDrawerContent, AvailabilityResultDrawerContentMargin, AvailabilityResultDrawerButtonWrapper, AvailabilityResultMessageContainer, AvailabilityResultStoreDetails };